// mutation types
export const SET_BUILDER = "setBuilder";

export default {
    state: {
        builder: {}
    },
    getters: {
        builderPrefs(state) {
            return state.builder;
        }
    },
    actions: {
        [SET_BUILDER](state, payload) {
            state.commit(SET_BUILDER, payload);
        }
    },
    mutations: {
        [SET_BUILDER](state, payload) {
            state.builder = payload;
        }
    }
};
